import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { ContainersAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const mergeContainer = createAsyncThunk<ContainersAPI, number>(
  `${Slices.CONTAINER}/merge`,
  async (container_id, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get(`/containers/${container_id}`);
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
